// 双币历史订单状态
export const STRUCTURED_ORDER_STATUS = {
  fail: "status.failed", // 失败
  rejected: "status.failed", // 失败
  filled: "status.subscribed", // 已申购
  redeeming: "status.redeeming", // 赎回中
  redeemed: "status.redeeming", // 赎回中
  settling: "status.redeeming", // 赎回中
  settled: "status.settled", // 已结算
};

// 双币订单状态筛选项与后端状态映射表
export const STRUCTURED_ORDER_STATUS_FILTER_MAP = {
  fail: ["fail", "rejected"],
  filled: ["filled"],
  redeeming: ["redeeming", "redeemed", "settling"],
  settled: ["settled"],
};

//累计期权订单状态
export const ACCUMULATOR_ORDER_STATUS = {
  fail: "status.failed", // 申购失败
  filled: "status.subscribed", // 已申购
  rejected: "status.failed", // 申购失败
  partial_redeemed: "status.subscribed", //赎回中
  settled: "status.expired", // 已到期
  settling: "status.subscribed", //赎回中
  terminal: "status.terminal", //已终止
};

// 累计期权订单状态筛选项与后端状态映射表
export const ACCUMULATOR_ORDER_STATUS_FILTER_MAP = {
  fail: ["fail", "rejected"],
  filled: ["filled", "settling", "partial_redeemed"],
  settled: ["settled"],
};

//雪球订单状态
export const SNOWBALL_ORDER_STATUS = {
  filled: "status.subscribed", // 已申购
  fail: "status.failed", // 申购失败
  rejecting: "status.failed", // 申购失败
  rejected: "status.failed", // 申购失败
  redeeming: "status.redeemed", //赎回中
  redeemed: "status.redeemed", //赎回中
  settled: "status.settled", // 已结算
  settling: "status.settled", //已结算
};

// 雪球订单状态筛选项与后端状态映射表
export const SNOWBALL_ORDER_STATUS_FILTER_MAP = {
  filled: ["filled"],
  fail: ["fail", "rejecting", "rejected"],
  redeeming: ["redeeming", "redeemed"],
  settled: ["settled", "settling"],
};

// 业务类型与多语言 key 映射表
export const BUSINESS_TYPE = {
  1: "enums.business.type.withdraw",
  2: "enums.business.type.deposit",
  4: "enums.business.type.inner.withdraw",
  10: "enums.business.type.yield.subscription",
  12: "enums.business.type.interests",
  15: "enums.business.type.yield.redemption",
  24: "enums.business.type.spot.trade",
  25: "enums.business.type.fiat.deposit",
  26: "enums.business.type.fiat.withdraw",
  31: "enums.business.type.dca",
  35: "enums.business.type.dust.transaction",
  37: "enums.business.type.autoInvest",
  38: "enums.business.type.fixed.subscribe",
  39: "enums.business.type.fixed.subscribe.cancel",
  41: "enums.business.type.fixed.redeem",
  44: "enums.business.type.staking",
  45: "enums.business.type.staking.rewards",
  46: "enums.business.type.staking.redemption",
  50: "enums.business.type.dual",
  53: "enums.business.type.accumulator",
  55: "enums.business.type.snowball",
  81: "enums.business.type.aum.fee",
  82: "enums.business.type.commission",
  83: "enums.business.type.strategy.subscription",
  84: "enums.business.type.strategy.redemption",
  86: "enums.business.type.strategy.subscription.cancel",
  113: "enums.business.type.transfer.from.vault",
};

// 现货交易订单状态
export const SPOT_ORDER_STATUS = {
  filled: "enums.spot.history.status.filled",
  cancelled: "enums.spot.history.status.cancelled",
  rejected: "enums.spot.history.status.rejected",
  fail: "enums.spot.history.status.fail",
  partial_filled_cancelled: "enums.spot.history.status.partial_filled_cancelled",
};
// 现货交易订单买卖
export const SPOT_ORDER_SIDE = {
  buy: "enums.spot.history.side.buy",
  sell: "enums.spot.history.side.sell",
};

// 现货交易订单类型
export const SPOT_ORDER_TYPE = {
  limit: "enums.spot.order.type.limit",
  market: "enums.spot.order.type.market",
};

// 基金历史订单类型
export const FUND_ORDER_TYPE = {
  0: "status.subscription",
  1: "status.redemption",
};

// Venture 产品份额类型枚举
// 用于统一 APP 和 Web 端的 venture shares 类型判断
// 避免在代码中使用魔法数字 0 和 1
export enum VentureListSharesTypes {
  /** 主要份额 - 需要 KYC 认证才能查看 */
  primary = 0,
  /** 次要份额 - 所有用户都可以查看 */
  secondary = 1,
}
